// Function loadCardsContainerBlock loads the CardsContainerBlock class by dynamically importing the js on demand if needed

export function loadCardsContainerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-cards-container-block-chunk" */ '../widgets/cardsContainerBlock').then(wg => {

		const { CardsContainerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="CardsContainerBlock"]');

		if(!$wg) {
			// console.info('CardsContainerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="CardsContainerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new CardsContainerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new CardsContainerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the CardsContainerBlock widget');

}
